/**
 * Constantes para el manejo de sucursales
 */

import type { User } from "./auth-context";

/**
 * ID especial para representar "Todas las sucursales"
 * Solo disponible para Administrador Global
 */
export const ALL_SUCURSALES_ID = -1;

/**
 * Objeto especial que representa "Todas las sucursales"
 */
export const ALL_SUCURSALES = {
  id: ALL_SUCURSALES_ID,
  codigo: "ALL",
  nombre: "Todas las sucursales",
  direccion: "",
  telefono: "",
  is_active: true,
};

/**
 * Verifica si el usuario es Administrador Global
 * Admin Global tiene permiso "*" o rol "Administrador Global"
 */
export function isGlobalAdmin(user: User | null): boolean {
  if (!user) return false;
  return user.permissions?.includes("*") || user.role?.name === "Administrador Global";
}
